Ext.define('SA.model.Institution', {
    constructor({name, locale, countries, userAuthenticationMethod}) {
        this.name = name;
        this.locale = locale;
        this.countries = countries;
        this.userAuthenticationMethod = userAuthenticationMethod;
    },

    eachCountry(fn, scope) {
        this.getCountries().forEach(fn, scope);
    },

    getCountries() {
        return Object.values(this.countries);
    },

    getCountry(countryCode) {
        return this.countries[countryCode];
    },

    getCountryCodes() {
        return Object.keys(this.countries);
    },

    getLocale() {
        return this.locale;
    },

    getBcp47Tag() {
        switch (this.locale) {
            case 'CAN':
                return 'en-CA';
            case 'USA':
                return 'en-US';
        }
    },

    getLocationSeriesForCountries() {
        return this.getCountries().map(country => country.getLocationSeries());
    },

    getName() {
        return this.name;
    },

    hasLibraryCardAuthentication() {
        return this.userAuthenticationMethod === 'libraryCard';
    },

    isCanadaOnly() {
        return this.isSingleCountry() && this.getCountries()[0].isCanada();
    },

    isSingleCountry() {
        return this.getCountries().length === 1;
    },

    isUsaOnly() {
        return this.isSingleCountry() && this.getCountries()[0].isUSA();
    },

    maybeRemoveDMAs() {
        this.eachCountry(country => country.maybeRemoveDMAs());
    }
});
